import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const PageNotAssigned = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Öffne das Modal automatisch beim Laden der Seite
    setShowModal(true);
  }, []);

  const handleRandomPage = () => {
    alert('Zufällige Seite erstellen!');
    // Hier könnte man eine Funktion aufrufen, die den Benutzer zu einer zufälligen Seite leitet
  };

  const handleShopRedirect = () => {
    alert('Zum Shop weiterleiten!');
    // Hier könnte man den Benutzer zum Shop weiterleiten
  };

  return (
    <div className="custom-modal">
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Hinweis</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Diese Seite ist noch nicht vergeben. Kaufe dir jetzt ein Shirt und erstelle deine eigene Seite oder lasse dir eine zufällige Seite erstellen.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleRandomPage}>
            Zufällige Seite
          </Button>
          <Button variant="primary" onClick={handleShopRedirect}>
            Zum Shop
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PageNotAssigned;